var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06055 1.06066L9.06055 9.06066M17.0605 17.0607L9.06055 9.06066M9.06055 9.06066L17.0605 1.06066M9.06055 9.06066L1.06055 17.0607",
    stroke: "#B20116",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedIcon);
export default __webpack_public_path__ + "static/media/failedIcon.68a9e8f2ee01dea3d504eabdc24283fb.svg";
export { ForwardRef as ReactComponent };